export const ActOrderEnum = {
    TELEMEDICAL: [{id: 13, place_order: 0}],
    ORTHOPTIC_EVALUATION:[],
    FUNCTIONAL_EXPLORATION:[],
    REEDUCATION:[],
    NURSE:[],
    SCREENING: []
}